var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuizApp',{attrs:{"settings":_vm.settings,"isPreview":_vm.isPreview,"onStart":_vm.handleOnStart,"onSubmit":_vm.handleOnSubmit,"onResult":_vm.handleOnResult},on:{"isPreview":(value) => (_vm.isPreview = value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }